import { useState, useRef } from 'react';
import { Smartphone, Tv, Zap, Droplet, Wind, Globe, CreditCard, BookOpen, DollarSign } from 'react-feather';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './ServicesSection.css';

const servicesRow1 = [
  {
    icon: <Smartphone size={30} color="#ffffff" />, title: 'Mobile Recharge',
    desc: 'Recharge prepaid numbers instantly'
  },
  {
    icon: <Tv size={30} color="#ffffff" />, title: 'DTH Recharge',
    desc: 'Fast activation for all DTH providers'
  },
  {
    icon: <Zap size={30} color="#ffffff" />, title: 'Electricity Bills',
    desc: 'Pay electricity bills instantly'
  },
  {
    icon: <Droplet size={30} color="#ffffff" />, title: 'Water Bills',
    desc: 'Clear water bills quickly and securely'
  },
  {
    icon: <Wind size={30} color="#ffffff" />, title: 'Gas Bills',
    desc: 'Pay gas bills or book refills hassle-free'
  },
];

const servicesRow2 = [
  {
    icon: <Globe size={30} color="#ffffff" />, title: 'Broadband & Landline',
    desc: 'Pay bills with instant receipts'
  },
  {
    icon: <CreditCard size={30} color="#ffffff" />, title: 'Data Card Recharge',
    desc: 'Recharge data cards on-the-go'
  },
  {
    icon: <BookOpen size={30} color="#ffffff" />, title: 'Education Fees',
    desc: 'Pay school and college fees easily'
  },
  {
    icon: <DollarSign size={30} color="#ffffff" />, title: 'Loan & Finance',
    desc: 'Access micro-loans and EMI payments'
  },
];

function ServicesSection() {
  const { sectionRef, isVisible } = useIntersectionObserver();

  return (
    <section id="services" className="services" ref={sectionRef}>
      <div className="services-wrapper">
        <h1 className={`services-title ${isVisible ? 'animate' : ''}`}>Discover Our Services</h1>
        <p className={`services-subtitle ${isVisible ? 'animate' : ''}`}>
          Explore our services that make your life more convenient
        </p>
        <div className="services-rows">
          <div className={`services-row row-right ${isVisible ? 'animate' : ''}`}>
            {[...servicesRow1, ...servicesRow1].map((service, idx) => (
              <div key={idx} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            ))}
          </div>
          <div className={`services-row row-left ${isVisible ? 'animate' : ''}`}>
            {[...servicesRow2, ...servicesRow2].map((service, idx) => (
              <div key={idx} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
